'use strict'

var trim = require('trim')

exports.parse = parse
exports.stringify = stringify

var empty = ''
var space = ' '
var whiteSpace = /[ \t\n\r\f]+/g

function parse(value) {
  var input = trim(String(value || empty))
  return input === empty ? [] : input.split(whiteSpace)
}

function stringify(values) {
  return trim(values.join(space))
}



//////////////////
// WEBPACK FOOTER
// ./~/space-separated-tokens/index.js
// module id = 215
// module chunks = 95715928098905 168707334958949